import React from "react";

export default function Header({ showLogo, logoUrl, showMenuCaption, menuCaptionText, menuCaptionSize }) {
  return (
    <header className="menu-topbar">
      <div className="menu-topbar-inner">
        <div className="menu-logo-container">
          {showLogo && logoUrl && (
            <img src={logoUrl} alt="Logo" className="menu-logo" />
          )}
          {showMenuCaption && (
            <h1 className="menu-caption" style={{ fontSize: menuCaptionSize }}>
              {menuCaptionText}
            </h1>
          )}
        </div>
      </div>
    </header>
  );
}
